import { render, staticRenderFns } from "./EstadoPatente.vue?vue&type=template&id=e349d216&scoped=true&"
import script from "./EstadoPatente.vue?vue&type=script&lang=ts&"
export * from "./EstadoPatente.vue?vue&type=script&lang=ts&"
import style0 from "./EstadoPatente.vue?vue&type=style&index=0&id=e349d216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e349d216",
  null
  
)

export default component.exports